<template lang="pug">
section.media-info-icons.info.row
  .views.d-flex( :class="{ active : post.my_xp.seen }" )
    span.dashicons.dashicons-visibility
    span.count {{ post.stats.views || 0 }}
  .likes.d-flex(
    :class="{ active: post.my_xp.like }"
    @click.stop="likePost"
  )
    span.dashicons.dashicons-thumbs-up
    span.count {{ post.stats.likes || 0 }}
  .dislikes.d-flex(
    :class="{ active: post.my_xp.dislike }"
    @click.stop="dislikePost"
  )
    span.dashicons.dashicons-thumbs-down
    span.count {{ post.stats.dislikes || 0 }}
  .favs.d-flex(
    :class="[ { active: post.my_xp.fav }]"
    @click.stop="favPost"
  )
    span.dashicons.dashicons-star-filled
    span.count {{ post.stats.favs || 0 }}
  .comments.d-flex( :class="{ active: post.my_xp.comment }" )
    span.dashicons.dashicons-admin-comments
    span.count {{ post.stats.comments || 0 }}
</template>

<script lang="js">

export default {
  name: 'media-info-icons',
  mixins: [],
  components: {},
  props: {
    post: {
      type: Object,
      required: true
    },
  },
  data() {
    return {
    }
  },
  created() {},
  mounted() {},
  methods: {
    likePost() {
    },
    dislikePost() {
    },
    favPost() {
    }
  },
  computed: {}
}
</script>

<style lang="scss">
.media-info-icons {

}
</style>
